import {
    FETCH_LOAN_AVAILABLE_PROPS_BEGIN,
    FETCH_LOAN_AVAILABLE_PROPS_ERROR,
    FETCH_LOAN_AVAILABLE_PROPS_SUCCESS
} from "../actions/loan/loanAvailablePropertyActions";

const defaultLoanAvailableProps = {
    loanAvailableProps: {
        bankProps: [],
        retailerProps: []
    },
    loading: false,
    error: null
};

export const loanAvailableProps = (state = defaultLoanAvailableProps, action) => {
    switch (action.type) {
        case FETCH_LOAN_AVAILABLE_PROPS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_LOAN_AVAILABLE_PROPS_SUCCESS:
            return {
                ...state,
                loading: false,
                loanAvailableProps: action.payload.loanAvailableProps,
            };
        case FETCH_LOAN_AVAILABLE_PROPS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/loanAvailableProperty.js